import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Button, Row, Col } from 'reactstrap';
import { PlusCircle, Edit, X, Calendar, Award } from 'react-feather';

const MinigameFormModal = ({ 
  isOpen, 
  toggle, 
  editMode, 
  formData, 
  onChange, 
  onSubmit, 
  loading 
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle} className="bg-light">
        <div className="d-flex align-items-center">
          <div className="bg-success bg-opacity-10 rounded-circle p-2 me-3">
            {editMode ? <Edit size={20} className="text-success" /> : <PlusCircle size={20} className="text-success" />}
          </div>
          <div>
            <h5 className="mb-0">
              {editMode ? '✏️ Chỉnh sửa Minigame' : '➕ Tạo Minigame Mới'}
            </h5>
            <small className="text-muted">
              {editMode ? 'Cập nhật thông tin minigame' : 'Thêm minigame vòng quay mới'}
            </small>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="p-4">
        <FormGroup>
          <Label className="fw-bold">
            Tên Minigame <span className="text-danger">*</span>
          </Label>
          <Input
            type="text"
            name="title"
            value={formData.title}
            onChange={onChange}
            placeholder="Ví dụ: Vòng quay may mắn Tết 2024"
            className="form-control-lg"
          />
        </FormGroup>

        <FormGroup>
          <Label className="fw-bold">
            Mô tả <span className="text-danger">*</span>
          </Label>
          <Input
            type="textarea"
            name="description"
            rows="4"
            value={formData.description}
            onChange={onChange}
            placeholder="Nhập mô tả chi tiết về minigame..."
          />
        </FormGroup>

        <Row>
          <Col md="6">
            <FormGroup>
              <Label className="fw-bold">
                <Calendar size={16} className="me-2" />
                Ngày bắt đầu <span className="text-danger">*</span>
              </Label>
              <Input
                type="datetime-local"
                name="startDate"
                value={formData.startDate}
                onChange={onChange}
                className="form-control-lg"
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <Label className="fw-bold">
                <Calendar size={16} className="me-2" />
                Ngày kết thúc <span className="text-danger">*</span>
              </Label>
              <Input
                type="datetime-local"
                name="endDate"
                value={formData.endDate}
                onChange={onChange}
                min={formData.startDate}
                className="form-control-lg"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <FormGroup>
              <Label className="fw-bold">
                <Award size={16} className="me-2" />
                Phần thưởng (điểm) <span className="text-danger">*</span>
              </Label>
              <Input
                type="number"
                name="reward"
                value={formData.reward}
                onChange={onChange}
                min="0"
                placeholder="Nhập số điểm..."
                className="form-control-lg"
              />
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup>
              <Label className="fw-bold">
                Trạng thái <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                name="status"
                value={formData.status}
                onChange={onChange}
                className="form-control-lg"
              >
                <option value="active">✅ Hoạt động</option>
                <option value="inactive">⏸️ Tạm dừng</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="bg-light">
        <Button color="secondary" onClick={toggle} disabled={loading}>
          <X size={16} className="me-2" />
          Hủy
        </Button>
        <Button color="success" onClick={onSubmit} disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Đang xử lý...
            </>
          ) : (
            <>
              {editMode ? <Edit size={16} className="me-2" /> : <PlusCircle size={16} className="me-2" />}
              {editMode ? 'Cập nhật' : 'Tạo mới'}
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MinigameFormModal;

